<template>
  <div
    class="video-review"
    data-testid="landing-video-review"
  >
    <div class="video-review__wrapper">
      <VideoFallback
        ref="videoRef"
        src="/video/video_reviews_landing.mp4"
        :loop="false"
        :muted="false"
        :autoplay="false"
        poster="/video/posters/video_reviews.gif"
        :controls="isVideoPlaying"
        :play-delay="-1"
        @play="showControls"
        @pause="hideControls"
        @ended="onVideoEnd"
        @click.stop
      />
      <nuxt-icon
        v-if="!isVideoPlaying && isShowVideo"
        name="button-play"
        filled
        @click.stop="togglePlay"
      />
    </div>

    <div
      v-if="sound"
      class="video-review__sound-wrapper"
    >
      <nuxt-icon name="sound" />
      <p class="video-review__sound-text paragraph-16-600">
        {{ $t('oldTranslations.landing.sound') }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  sound: {
    type: Boolean,
    default: true,
  },
});

const videoRef = ref<any>();
const isVideoPlaying = ref(false);
const route = useRoute();

const isShowVideo = computed(() => route.query.hv !== '1');

function showControls(): void {
  isVideoPlaying.value = true;
}

function hideControls(): void {
  isVideoPlaying.value = false;
}

function onVideoEnd(): void {
  videoRef.value.resetVideoTime();
}

function togglePlay() {
  if (!isVideoPlaying.value) {
    videoRef.value.onPlay();
  }
}
</script>

<style lang="scss" scoped>
.video-review {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 48px;
  width: 100%;

  &__wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 311px;
    position: relative;

    :deep(video),
    :deep(img) {
      width: 100%;
    }

    :deep(.nuxt-icon) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      line-height: 0;

      svg {
        height: 109px;
        width: 109px;
      }
    }
  }

  &__sound-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    margin-top: 30px;
    color: $blue;
    font-size: 22px;

    .nuxt-icon {
      line-height: 0;
    }
  }

  &__sound-text {
    color: $blue;
  }
}
</style>
